import { edpApiV1 } from './index';

export type TOrgStructure = {
  id: string;
  name: string;
  isAvailable: boolean;
};

export type TGetOrgstructureRequest = {
  search?: number;
};

export type TPatchOrgstructureRequest = {
  id?: string;
  isAvailable: boolean;
  all?: boolean;
};

export const orgStructureApi = edpApiV1.injectEndpoints({
  endpoints: build => ({
    getOrgStructureOrganizations: build.query<TOrgStructure[], TGetOrgstructureRequest>({
      query: payload => ({ url: '/v1/admin/org-structure/organizations', method: 'GET', params: payload }),
    }),
    updateOrgStructureOrganizations: build.mutation<string, TPatchOrgstructureRequest>({
      query: body => ({
        url: `/v1/admin/org-structure/organizations`,
        method: 'PATCH',
        body,
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetOrgStructureOrganizationsQuery,
  useLazyGetOrgStructureOrganizationsQuery,
  useUpdateOrgStructureOrganizationsMutation,
} = orgStructureApi;
